export enum AdhocSearchCardEnum {
  FLIGHT_CARD = "flight-card",
  LOAD_TYPE_CARD = "load-type-card",
  COMMODITY_CARD = "commodity-card",
  OPTIONS_CARD = "options-card",
}
